/** True when `now`'s local hour falls inside the [startHour, endHour) quiet window.
 *  Handles a window that wraps past midnight (startHour > endHour). Empty/undefined
 *  windows are never quiet. */
export function inQuietHours(
  q: { startHour: number; endHour: number } | undefined,
  now: Date,
): boolean {
  if (!q || q.startHour === q.endHour) return false;
  const h = now.getHours();
  return q.startHour < q.endHour
    ? h >= q.startHour && h < q.endHour
    : h >= q.startHour || h < q.endHour;
}
